import Tooltip from '@/components/molecules/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

// import components

const WeeeTax = ({ weeeTax }) => {
  const { t } = useTranslation();
  if (!weeeTax) return null;

  return (
    <div className='dln-orderRev--weeeTax'>
      <div className='--weeeTaxPrice'>
        {weeeTax.formattedValue}&nbsp;
        {t('weeetax.label')}
      </div>
      <Tooltip content={t('weeetax.tooltip.label')} glyphInner='' />
    </div>
  );
};

WeeeTax.propTypes = {
  weeeTax: PropTypes.shape().isRequired,
};

export default WeeeTax;
